<template>
  <div>
    <div class="virtual-viewport">
      <ResponsiveHandler></ResponsiveHandler>
      <div class="app-background">
        <div>
          <Header></Header>
        </div>
        <section class="app-content section-container">
          <div class="with-footer">
            <div class="non-footer-section">
              <router-view/>
            </div>
            <div>
              <Footer></Footer>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  import ResponsiveHandler from './views/ResponsiveHandler'
  import Header from './views/Header'
  import Footer from './views/Footer'

  export default {
    name: 'AppContainer',
    components: {
      'ResponsiveHandler': ResponsiveHandler,
      'Header': Header,
      'Footer': Footer,
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../scss/main";

  .virtual-viewport {
    height: 100vh;
    width: 100vw;
  }

  .app-background {
    background-color: $white-1;
    height: 100%;
    margin: 0 auto;
  }

  .app-content {
    height: calc(100% - #{$header-height});
    overflow-y: auto;
    @media #{$mobile} {
      height: calc(100% - #{$header-height-mobile});
    }

    .with-footer {
      height: 100%;

      .non-footer-section {
        min-height: calc(100% - #{$footer-height});
        @media #{$mobile} {
          min-height: calc(100% - #{$footer-height-mobile});
        }
      }
    }
  }

  /*.section-container{*/
  /*  max-width: 1024px;*/
  /*  margin: auto;*/
  /*}*/
</style>
